import React from 'react';
import Input from '../../ui/inputs/Input';
import DeleteIconButton from '../../ui/buttons/DeleteIconButton';
import PhoneInput from '../../ui/inputs/PhoneInput';

const IndicationForm = ({ index, indication, onChange, onRemove, canWrite = true }) => {
  const handleChange = (e) => {
    const { name, value } = e.target;
    onChange(index, { ...indication, [name]: value });
  };

  return (
    <div className="grid grid-cols-12 gap-8 items-center">
      <div className="col-span-12 md:col-span-4">
        <Input name="name" label="Nome" value={indication.name || ''} onChange={handleChange} disabled={!canWrite} />
      </div>

      <div className="col-span-12 md:col-span-4">
        <Input name="email" label="E-mail" value={indication.email || ''} onChange={handleChange} disabled={!canWrite} />
      </div>

      <div className="col-span-12 md:col-span-3">
        <PhoneInput
          name="phone"
          label="Telefone"
          value={indication.phone || ''}
          onChange={handleChange}
          disabled={!canWrite}
        />
      </div>

      {canWrite && (
        <div className="col-span-12 md:col-span-1 flex justify-center items-end h-full">
          <DeleteIconButton onClick={() => onRemove(index)} />
        </div>
      )}
    </div>
  );
};

export default IndicationForm;
